import { render, staticRenderFns } from "./TTPDOrderRefundAudit.vue?vue&type=template&id=4be492f0&"
import script from "./TTPDOrderRefundAudit.vue?vue&type=script&lang=js&"
export * from "./TTPDOrderRefundAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports